export default "__VITE_ASSET__DKA1fyhd__"